import { MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BtnOutlined, CmbWithTitle, Column, ContainerInside, ItemContainer, Items, LabelItem, ValueItem } from "../styled.components";
import FooterBtns from "../FooterBtns";
import { cloneObjectWithRegExp, hotToast, validateData } from "utils";
import { InputsGroup } from "Components/Inputs";
import { InputModal } from "Components/V1/InputModal";
import Table from "Components/V1/Table";
import SaveIcon from "@mui/icons-material/Save";
import ServiceArchivo from "service/archivos";
import { ICombo } from "Interfaces/Generics";
import IRelUsuarioMarcaOperacion from "ITables/RelUsuarioMarcaOperacion";


const SCHEMAUSUARIO = {
    error: false,
    required: true,
    type: "text",
    textError: "Ingresa un nombre valido",
};
const SCHEMADATA = {
    idArchivo: {
        error: false,
        required: true,
        type: "select",
        textError: "Ingresa un un archivo valido",
    },
    idMarca: {
        error: false,
        required: true,
        type: "select",
        textError: "Ingresa una marca valido",
    },
    idTipoOperacion: {
        error: false,
        required: true,
        type: "select",
        textError: "Ingresa un tipo de operacion valida",
    }

};

interface IRelUsrArchivoMT {
    idArchivo: number,
    idMarca: number,
    idRelacionArchivoMarcaTipoOp: number,
    nombreArchivo?: string,
    marcaTipoOperacion?: string,
    idEstatus: boolean
    idTipoOperacion : number,
}


const UdpdateRelUserFiles = ({ reloadData, closeModal, loading, setLoading, row }: any) => {
    const [idUsuario, setIdUsuario] = useState<number>(0)
    const [validateUser, setValidateUser] = useState(cloneObjectWithRegExp(SCHEMAUSUARIO));

    const [relUsrArchivoMT, setRelUsrArchivoMT] = useState<IRelUsrArchivoMT>({
        idArchivo: 0,
        idMarca: 0,
        idRelacionArchivoMarcaTipoOp: 0,
        idEstatus: true,
        idTipoOperacion: 0,
    })
    const [validate, setValidate] = useState(cloneObjectWithRegExp(SCHEMADATA));
    const [arrayRelUsrArchivoMT, setArrayRelUsrArchivoMT] = useState<Array<IRelUsrArchivoMT>>([])


    const [arrayUsers, setArrayUsers] = useState<Array<ICombo>>([])
    const [arrayArchivos, setArrayArchivos] = useState<Array<ICombo>>([])
    const [arrayMarcas, setArrayMarcas] = useState<Array<ICombo>>([])
    const [arrayTiposOperacion, setArrayTiposOperacion] = useState<Array<ICombo>>([])

    useEffect(() => {
        getAll();
    }, [])

    const getAll = async () => {
        ServiceArchivo.cbmUsuariosNoConfig({ setterFunc: setArrayUsers });
        const resDetalle = await ServiceArchivo.getRelUsuariosArchivosDetalle(row.idUsuario);

        const arrayResDetalle = resDetalle.map((d: any) => ({
            idRelacionArchivoMarcaTipoOp: d.idRelacionArchivoMarcaTipoOp,
            marcaTipoOperacion: d.marcaTipoOperacion,
            nombreArchivo: d.archivo,
            idEstatus: true
        }))
        setArrayRelUsrArchivoMT(arrayResDetalle);
        setIdUsuario(row.idUsuario)

        ServiceArchivo.getMarcas(setArrayMarcas, row.idUsuario);
    }

    const handleArchivo = (e: any) => {
        let value = e.target.value;
        setValidate((old: any) => ({ ...old, idArchivo: { ...old['idArchivo'], error: false } }))
        const oFile = arrayArchivos.find((item : any) => item.value === value) as any;
        setRelUsrArchivoMT((old: any) => ({
            ...old,
            idArchivo: value,
            nombreArchivo: arrayArchivos.find(d => d.value === value)?.label,
            idRelacionArchivoMarcaTipoOp : oFile?.idRelacionArchivoMarcaTipoOp,
        }))
    }

    const handleMarca = (e: any) => {
        let value = e.target.value;
        setValidate((old: any) => ({ ...old, idMarca: { ...old['idMarca'], error: false } }))
        ServiceArchivo.getTiposOperacion(setArrayTiposOperacion,value, idUsuario);
        setRelUsrArchivoMT((old: any) => ({
            ...old,
            idMarca: value,
            idArchivo: 0,
            idRelacionArchivoMarcaTipoOp: 0,
            idTipoOperacion: 0,
        }))
    }

    const handleOperacion = (e: any) => {
        let value = e.target.value;
        setValidate((old: any) => ({ ...old, idTipoOperacion: { ...old['idTipoOperacion'], error: false } }))
        setRelUsrArchivoMT((old: any) => ({
            ...old,
            idTipoOperacion: value,
            idArchivo: 0,
            idRelacionArchivoMarcaTipoOp : 0,
        }))
        ServiceArchivo.getFiles(setArrayArchivos,relUsrArchivoMT.idMarca, value, idUsuario);
    }

    const onSubmit = async () => {
        if (idUsuario === 0) { return hotToast("El campo de usuario no puede estar vacio", "ERROR") }
        if (!arrayRelUsrArchivoMT.some(d => d.idEstatus)) { return hotToast("Debes ingresar almenos una relacion de Archivo - Marca - Operación", "ERROR") }
        setLoading(true);
        const request = arrayRelUsrArchivoMT.map(d => ({ IdRelacionArchivoMarcaTipoOp: d.idRelacionArchivoMarcaTipoOp, Checked: d.idEstatus }))
        let response = await ServiceArchivo.updateRelUsuariosArchivos(request, idUsuario);
        if (response) {
            hotToast("El registro se guardo correctamente", "SUCCESS");
            setLoading(false);
            reloadData && reloadData();
            closeModal && closeModal();
            setValidate(SCHEMADATA);
        }
        setLoading(false);
    };

    const handleDelete = (item: any) => {
        setArrayRelUsrArchivoMT((old: any) => {
            let arr: Array<IRelUsrArchivoMT> = [...old];
            const index = arr.findIndex((d: any) => d.idRelacionArchivoMarcaTipoOp === item.idRelacionArchivoMarcaTipoOp);
            arr[index].idEstatus = false;
            return arr;
        });

    }
    
    const saveColumn = () => {
        let flag = validateData({ validate, data: relUsrArchivoMT }, setValidate);
        if (!flag) {
            let data: Array<IRelUsrArchivoMT> = [...arrayRelUsrArchivoMT];
            const fl: number = arrayRelUsrArchivoMT.findIndex(d => d.idRelacionArchivoMarcaTipoOp === relUsrArchivoMT.idRelacionArchivoMarcaTipoOp)
            if (fl > -1) {
                if(data[fl].idEstatus){
                    hotToast("La relación ya existe","WAR");
                }else{
                    data[fl].idEstatus = true;
                    setArrayRelUsrArchivoMT([...data]);
                }
                
                
            } else {
                const $marca = arrayMarcas.find((d) => d.value === relUsrArchivoMT.idMarca)?.label;
                const $operacion = arrayTiposOperacion.find((d) => d.value === relUsrArchivoMT.idTipoOperacion)?.label;
                setArrayRelUsrArchivoMT((old) => [...old, {
                    ...relUsrArchivoMT,
                    marcaTipoOperacion: `${$marca} - ${$operacion}`,
                    idEstatus: true
                }])
            }

            setRelUsrArchivoMT({
                idArchivo: 0,
                idMarca: 0,
                idRelacionArchivoMarcaTipoOp: 0,
                nombreArchivo: '',
                marcaTipoOperacion: '',
                idEstatus: true,
                idTipoOperacion : 0,
            });
        }
    }

    return (
        <ContainerInside>
            <InputsGroup>
                <ItemContainer>
                    <LabelItem>Nombre:</LabelItem>
                    <ValueItem>{row.nombre}</ValueItem>
                </ItemContainer>
            </InputsGroup>

            <Items>
                <Column ai={"flex-end"}>
                    <CmbWithTitle error={validate.idMarca.error}>
                        <span>Marca</span>
                        <InputModal
                            name="idArchivo"
                            id="slcIdArchivo"
                            minWidth={'300px'}
                            onChange={handleMarca}
                            value={relUsrArchivoMT.idMarca}
                            select
                            error={validate.idMarca.error}
                            helperText={validate.idMarca.error && validate.idMarca.textError}
                        >
                            {arrayMarcas &&
                                arrayMarcas.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                        </InputModal>

                    </CmbWithTitle>
                    <CmbWithTitle error={validate.idTipoOperacion.error}>
                        <span>Tipo de Operación</span>
                        <InputModal
                            name="idTipoOperacion"
                            id="slcIdTipoOperacion"
                            minWidth={'300px'}
                            onChange={handleOperacion}
                            value={relUsrArchivoMT.idTipoOperacion}
                            select
                            error={validate.idTipoOperacion.error}
                            helperText={validate.idTipoOperacion.error && validate.idTipoOperacion.textError}
                        >
                            {arrayTiposOperacion &&
                                arrayTiposOperacion.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                        </InputModal>

                    </CmbWithTitle>
                    <CmbWithTitle error={validate.idArchivo.error}>
                        <span>Archivo</span>
                        <InputModal
                            name="idArchivo"
                            id="slcIdArchivo"
                            minWidth={'300px'}
                            onChange={handleArchivo}
                            value={relUsrArchivoMT.idArchivo}
                            select
                            error={validate.idArchivo.error}
                            helperText={validate.idArchivo.error && validate.idArchivo.textError}
                        >
                            {arrayArchivos &&
                                arrayArchivos.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                        </InputModal>

                    </CmbWithTitle>
                   
                    <BtnOutlined
                        variant="outlined"
                        startIcon={<SaveIcon />}
                        onClick={saveColumn}
                    >
                        Guardar
                    </BtnOutlined>
                </Column>
                <Column jc={"flex-start"} mh="40vh" style={{overflow:'auto'}}>
                    <Table
                        IColumns={IRelUsuarioMarcaOperacion({
                            handleDelete
                        })}
                        IData={arrayRelUsrArchivoMT.filter(d => d.idEstatus)}
                        simply
                    />
                </Column>
            </Items>

            <FooterBtns
                handleCancel={closeModal}
                handleSubmit={onSubmit}
                loader={loading}
            />
        </ContainerInside >
    );
};

export default UdpdateRelUserFiles;
